import { z } from 'zod';

export const ImpersonationClientPickerModalFormSchema = z.object({
  CONTACT_ID: z.string().uuid(),
});

export type ImpersonationClientPickerModalForm = z.infer<
  typeof ImpersonationClientPickerModalFormSchema
>;
